module.exports = __webpack_public_path__ + "static/media/impactful.6b55f12f.png";